<template>
  <div class="adva_list">
    <ul>
      <li
        v-for="(item, i) in adva_list"
        :key="i"
        class="wow fadeInRight"
        :data-wow-delay="150 + 50 * i + 'ms'"
      >
        <img :src="item.smallImg" alt />
        <h4>{{ item.name }}</h4>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'advantage',
  props: {
    info: {
      type: Array
    }
  },
  data() {
    return {
      adva_list: this.info
    }
  },
  created() {
    console.log('this.info', this.info)
  }
}
</script>

<style lang="less" scoped>
.adva_list {
  max-width: 1400px;
  width: 100%;
  margin: 0px auto;

  ul {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background: #fff;
    padding: 60px 50px;
    padding-bottom: 5px;

    li {
      width: 27.75%;
      padding-right: 11%;
      color: #202640;
      position: relative;
      background: url('../../assets/images/advantage_line.png') right 0px top 66px no-repeat;
      background-size: 95px;

      &:last-child {
        width: 16.75%;
        padding-right: 0;
        background: transparent;
      }

      img {
        display: block;
        width: 70px;
        height: 70px;
        margin: 0 auto;
      }

      h4 {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        margin-top: 20px;
      }

      h6 {
        font-size: 16px;
        line-height: 26px;
        margin-top: 10px;
        font-weight: normal;
      }
    }
  }
  .linear {
    width: 80px;
    height: 1px;
    background: linear-gradient(to right, #fff 0%, #e61617 100%);
  }
}

@media (max-width: 768px) {
  .adva_list {
    ul {
      flex-wrap: wrap;
      padding: 40px 5%;

      li {
        width: 100%;
        margin-top: 20px;
        margin-right: 0;
        padding: 0;
        background: transparent;

        &:nth-child(-n + 2) {
          margin-top: 20px;
        }

        &:nth-child(-n + 1) {
          margin-top: 0;
        }

        &:last-child {
          width: 100%;
        }
      }
    }
  }
}
</style>
